import { render } from "./DonationsView.vue?vue&type=template&id=1f286f7d&scoped=true"
const script = {}

import "./DonationsView.vue?vue&type=style&index=0&id=1f286f7d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f286f7d"]])

export default __exports__